var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTasksIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 1013",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 202",
    d: "M0 0h48v48H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17965",
    d: "M12 12h24v24H12z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31525",
    d: "M36 15.816L22.308 29.52l-5.088-5.088 1.692-1.692 3.4 3.4 12-12zm-2.652 6.048A9.594 9.594 0 1124 14.4a9.505 9.505 0 015.136 1.5l1.728-1.728A11.88 11.88 0 0024 12a12.032 12.032 0 1011.28 7.932z",
    fill: "#fff"
  })));
}

export default SvgTasksIcon;